import {useMemo} from 'react';

import {groupByTrustStatus} from '../../utils';
import {TrustAccountMemberCard} from '../TrustAccountGridCard';
import {TrustAccountStatusSections} from '../TrustAccountStatusSections';

import type {
  MemberTrustAccountListHandlers,
  MemberTrustAccountListItem,
  TrustAccountGroupFold
} from '../../utils';

export interface TrustAccountCardListProps extends MemberTrustAccountListHandlers {
  items: MemberTrustAccountListItem[];
  /** Pins the caller's role to each tile — for the "all" tab, where cards of every role mix. */
  showRoleBadge?: boolean;
  groupFold: TrustAccountGroupFold;
}

/** The member list as cards, one foldable section per status (active first); empty statuses get none. */
export function TrustAccountCardList({items, groupFold, ...cardProps}: TrustAccountCardListProps) {
  const groups = useMemo(() => groupByTrustStatus(items), [items]);

  return (
    <TrustAccountStatusSections
      groups={groups}
      groupFold={groupFold}
      renderItem={item => <TrustAccountMemberCard item={item} {...cardProps} />}
    />
  );
}
